import { Button } from "antd";
import React, { FC } from "react";
import classes from "../../pages/Arrangments/Archive.module.css";

interface IButtonsProps {
	text: string;
	onClick?: () => void;
}

const Buttons: FC<IButtonsProps> = ({ text, onClick }) => {
	return (
		<div className={classes.buttonDiv}>
			<Button className={classes.button} onClick={onClick}>
				{text}
			</Button>
		</div>
	);
};

export default Buttons;
